import { useContext, useEffect } from "react";
import { Context } from "../../../context";
import { Box, Card, CircularProgress, Grid2, Typography } from "@mui/material";
import { Layout } from "../../../containers/layout/dashboard";
import { DashboardWrapper } from "./styled";
import { dashboardCards } from "../../../config/static";
import { retrieveSystemOverviewService } from "../../../utils/apis/overview";
import Cookies from "universal-cookie";
import { useQuery } from '@tanstack/react-query';

export const Dashboard = () => {
    const cookies = new Cookies();
    const TOKEN = cookies.getAll().TOKEN;

    const { setActiveNavItem } = useContext(Context);

    useEffect(() => {
        setActiveNavItem("Dashboard");
    }, [setActiveNavItem]);

    const { data: overview, isLoading } = useQuery({
        queryKey: ['systemOverview', TOKEN],
        queryFn: () => retrieveSystemOverviewService(TOKEN),
        enabled: !!TOKEN,
    });

    return (
        <Layout
            id="dashboard"
        >
            <DashboardWrapper>
                <Typography
                    variant="h1"
                    fontFamily={"Inter"}
                    fontWeight={700}
                    fontSize={24}
                    lineHeight={"normal"}
                    color={"#373737"}
                >
                    Dashboard
                </Typography>
                <Grid2
                    container
                    spacing={3}
                    component={"div"}
                    className="grid-container"
                >
                    {dashboardCards.map((dashboardCard, index) => {
                        return (
                            <Grid2
                                key={index}
                                size={{ mobile: 12, laptop: 6, desktop: 4 }}
                            >
                                <Card
                                    className="dashboard-card"
                                >
                                    <Box
                                        component={"div"}
                                        className="icon-box"
                                        sx={{
                                            backgroundColor: dashboardCard.bg
                                        }}
                                    >
                                        {dashboardCard.icon}
                                    </Box>
                                    <Box
                                        component={"div"}
                                        className="label-box"
                                    >
                                        <Typography
                                            variant="h2"
                                            fontFamily={"Inter"}
                                            fontWeight={400}
                                            fontSize={16}
                                            lineHeight={"normal"}
                                            color="#373737"
                                            marginBlock={"1rem"}
                                            whiteSpace={"normal"}
                                        >
                                            {dashboardCard.name}
                                        </Typography>
                                        <Typography
                                            variant="body1"
                                            fontFamily={"Inter"}
                                            fontWeight={800}
                                            fontSize={20}
                                            lineHeight={"normal"}
                                            color="#373737"
                                        >
                                            {isLoading ? (
                                                <CircularProgress color="inherit" className="loader" />
                                            ) : (
                                                dashboardCard?.name === "NO. OF INSTITUTIONS" ? overview?.totalInstitutions : dashboardCard?.no
                                            )}
                                        </Typography>
                                    </Box>
                                </Card>
                            </Grid2>
                        )
                    })}
                </Grid2>
            </DashboardWrapper>
        </Layout>
    )
}